/* eslint-disable */
import * as Types from './types';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../../fetcher';
export type GetTranslatableResourcesQueryVariables = Types.Exact<{
  locale: Types.Scalars['String'];
  ids: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
}>;


export type GetTranslatableResourcesQuery = { __typename?: 'QueryRoot', translatableResourcesByIds: { __typename?: 'TranslatableResourceConnection', nodes: Array<{ __typename?: 'TranslatableResource', resourceId: string, translations: Array<{ __typename?: 'Translation', value?: string | null }> }> } };

export declare const getTranslatableResources: import("graphql").DocumentNode;

export const GetTranslatableResourcesDocument = /*#__PURE__*/ `
    query getTranslatableResources($locale: String!, $ids: [ID!]!) {
  translatableResourcesByIds(resourceIds: $ids, first: 250) {
    nodes {
      resourceId
      translations(locale: $locale) {
        value
      }
    }
  }
}
    `;
export const useGetTranslatableResourcesQuery = <
      TData = GetTranslatableResourcesQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables: GetTranslatableResourcesQueryVariables,
      options?: UseQueryOptions<GetTranslatableResourcesQuery, TError, TData>
    ) =>
    useQuery<GetTranslatableResourcesQuery, TError, TData>(
      ['getTranslatableResources', variables],
      fetcher<GetTranslatableResourcesQuery, GetTranslatableResourcesQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetTranslatableResourcesDocument, variables, options),
      options
    );

useGetTranslatableResourcesQuery.getKey = (variables: GetTranslatableResourcesQueryVariables) => ['getTranslatableResources', variables];
;

useGetTranslatableResourcesQuery.fetcher = (dataSource: { endpoint: string, fetchParams?: RequestInit }, variables: GetTranslatableResourcesQueryVariables, options?: RequestInit['headers']) => fetcher<GetTranslatableResourcesQuery, GetTranslatableResourcesQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetTranslatableResourcesDocument, variables, options);